import { FC } from 'react';
import Image from 'next/image';

import { useMediaQueryWidthPicker } from '@/hooks';

interface CardImageProps {
  src: string;
  alt: string;
  className?: string;
}

export const CardImage: FC<CardImageProps> = ({
  src = '',
  alt = '',
  className = '',
}) => {
  const { device, screenWidth } = useMediaQueryWidthPicker();

  return (
    <Image
      className={className}
      src={src}
      alt={alt}
      width={device != 'mobile' ? 200 : screenWidth - 148}
      height={device != 'mobile' ? 200 : screenWidth - 148}
    />
  );
};
